import api from '@/api'
import baseJs from '@/transformer/base'

const getDefaultState = () => {
  return {
    prefectures: [],
    profileApiStatus: baseJs.getApiStatusEmpty(),
    profile: {},
    fileRequirements: {
      newPfIcoSize: 0, // 変更後のアイコン画像のサイズ
      newPfBgSize: 0 // 変更後の背景画像のサイズ
    }
  }
}

const mutations = {
  setPrefectures(state, prefectures) {
    state.prefectures = [...prefectures]
  },
  setProfile(state, profile) {
    state.profile = { ...profile }
  },
  setProfileApiStatus(state, apiStatus) {
    state.profileApiStatus = { ...apiStatus }
  },
  setfileRequirements(state, fileRequirements) {
    state.fileRequirements = {
      ...fileRequirements
    }
  },
  setNewPfBgSize(state, size) {
    state.fileRequirements.newPfBgSize = size
  },
  setNewPfIcoSize(state, size) {
    state.fileRequirements.newPfIcoSize = size
  }
}

const actions = {
  async getProfile({ commit }) {
    commit('setProfileApiStatus', baseJs.getApiStatusEmpty())
    try {
      const res = await api.profile.info()
      commit('setProfile', res.info)
      commit('setPrefectures', res.prefectures)
      commit('setProfileApiStatus', baseJs.getApiStatusSuccess())
      const fileRequirements = {
        newPfIcoSize: res.info.pf_ico_size,
        newPfBgSize: res.info.pf_bg_size
      }
      commit('setfileRequirements', fileRequirements)
      return Promise.resolve()
    } catch (err) {
      commit('setProfileApiStatus', { ...baseJs.getErrorStatus(err) })
      return Promise.reject(err)
    }
  }
}

const getters = {
  prefectureList(state) {
    const returnArray = []
    state.prefectures.map((e) => {
      returnArray[e.id] = e.name
    })
    return returnArray
  },

  prefectureName: (state) => (id) => {
    const prefecture = state.prefectures.find((prefecture) => Number(prefecture.id) === Number(id))
    if (!prefecture) {
      return '不明'
    }
    return prefecture.name
  },

  totalUploadableSpace(state) {
    if (state.profile.space_remained >= state.profile.max_pf_ico_size + state.profile.max_pf_bg_size) {
      return state.profile.max_pf_ico_size + state.profile.max_pf_bg_size
    }
    if (state.profile.pf_bg_size + state.profile.pf_ico_size + state.profile.space_remained <= 0) {
      // アップロード済みファイルを考慮してもアップロードできる余地がない
      return 0
    }
    // 空き容量が少ない時がまだある時は、ファイル上書きで空くスペースのことも考える
    return state.profile.pf_bg_size + state.profile.pf_ico_size + state.profile.space_remained
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
  getters
}
